<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p>{{ $t('onboarding.nestle.myFirstDayPage.title') }}</p>
      </div>
      <div class="body">
        <div class="description">
            <p>{{ $t('onboarding.nestle.myFirstDayPage.introduction') }}</p>
            <div class="dividing-line"></div>
        </div>
        <div class="text-board clear-margin-top" @click="toVuePage({ path: `/onboarding/${invitationId}/nestle/my-first-day-cn`})">
          <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPage.gcr') }}</p>
          <p class="board-subtitle">{{ $t('onboarding.nestle.myFirstDayPage.information') }}</p>
        </div>
        <div class="image-board clear-margin-top" @click="toVuePage({ path: `/onboarding/${invitationId}/nestle/my-first-day-cn`})">
            <img :src="firstImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPage.china') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board flex-derection-row-reverse" @click="toVuePage({ path: `/onboarding/${invitationId}/nestle/my-first-day-hk`})">
            <img :src="secondImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPage.hk') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board" @click="toVuePage({ path: `/onboarding/${invitationId}/nestle/my-first-day-tw`})">
            <img :src="thirdImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPage.tw') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      firstImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/chinaSite.jpg' : '@/assets/image/onboarding/my-first-day/pc/chinaSite.jpg'),
      secondImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/hkSite.jpg' : '@/assets/image/onboarding/my-first-day/pc/hkSite.jpg'),
      thirdImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/twSite.jpg' : '@/assets/image/onboarding/my-first-day/pc/twSite.jpg')
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/my-first-day/h5/banner.jpg');
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/my-first-day/pc/banner.jpg');
    }
  }
}
</style>
